import React from 'react';
import { useParams } from 'react-router';
import AntdProForm from '@ant-design/pro-form';
import { useQuery, useMutation } from '@apollo/client';
import moment from 'moment';
import PropTypes from 'prop-types';
import ExtensionForm from './ExtensionForm';
import { UPDATE_EXTENSION, GET_EXTENSION } from '../../../gql/extensions';
import ProfileInfo from './components/ProfileInfo';
import useLoading from '../../../hooks/useLoading';
import { convertFilesForInitialValues, getId } from '../../../utils';
import { useProjectFrozen } from 'hooks';

const EditExtension = ({ reducer: { dispatch } }) => {
  const { projectId, id } = useParams();
  const projectFrozen = useProjectFrozen(projectId);
  const [form] = AntdProForm.useForm();
  const { data, loading } = useQuery(GET_EXTENSION, {
    variables: {
      ids: [id],
      projectIds: [projectId],
      status: ['DRAFT', 'PENDING', 'REJECTED', 'APPROVED', 'VOIDED'],
    },
  });
  const [updateExtension, { loading: updateLoading }] = useMutation(
    UPDATE_EXTENSION,
    {
      refetchQueries: [
        {
          query: GET_EXTENSION,
          variables: { ids: [id], projectIds: [projectId] },
          status: ['DRAFT', 'PENDING', 'REJECTED', 'APPROVED', 'VOIDED'],
        },
      ],
    }
  );
  useLoading(updateLoading);

  const extension = data?.extensions[0];

  const initialValues = {
    date: moment(extension.date).isValid() ? moment(extension.date) : moment(),
    progressReport: convertFilesForInitialValues(extension.progressReport),
    supplements: convertFilesForInitialValues(extension.supplements),
    newCompletionDate: moment(extension.newCompletionDate),
    justification: extension.justification,
  };
  const onFinish = async (values) => {
    try {
      await updateExtension({
        variables: {
          input: {
            projectId,
            id,
            newCompletionDate: moment(values.newCompletionDate).format(
              'YYYY-MM-DD'
            ),
            progressReport: getId(values.progressReport)[0],
            supplements: getId(values.supplements),
            justification: values.justification,
          },
        },
      });
      dispatch({ type: 'SUBMIT' });
    } catch (error) {
      console.log({ error });
    }
  };

  return (
    <>
      <ProfileInfo />
      <ExtensionForm
        loading={loading}
        form={form}
        onFinish={onFinish}
        projectFrozen={projectFrozen}
        initialValues={initialValues}
      />
    </>
  );
};

EditExtension.propTypes = {
  reducer: PropTypes.object.isRequired,
};

export default EditExtension;
